/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayslipThemeColors } from './PlayslipThemeColors';
import {
    PlayslipThemeColorsFromJSON,
    PlayslipThemeColorsFromJSONTyped,
    PlayslipThemeColorsToJSON,
} from './PlayslipThemeColors';

/**
 * A replacement for a theme's colours, logo and copy. Every role is replaced, so one left out is
 * cleared and the client falls back to its built-in value for that role. The theme's identifier
 * cannot be changed.
 * @export
 * @interface PlayslipThemeUpdateRequest
 */
export interface PlayslipThemeUpdateRequest {
    /**
     * The reworded copy. Replaced like the colours, so leaving it out clears it.
     * @type {{ [key: string]: string; }}
     * @memberof PlayslipThemeUpdateRequest
     */
    messages?: { [key: string]: string; };
    /**
     * The retailer's logo URL. Replaced like the colours, so leaving it out clears it.
     * @type {string}
     * @memberof PlayslipThemeUpdateRequest
     */
    partnerLogoUrl?: string | null;
    /**
     * 
     * @type {PlayslipThemeColors}
     * @memberof PlayslipThemeUpdateRequest
     */
    colors: PlayslipThemeColors;
}

/**
 * Check if a given object implements the PlayslipThemeUpdateRequest interface.
 */
export function instanceOfPlayslipThemeUpdateRequest(value: object): value is PlayslipThemeUpdateRequest {
    if (!('colors' in value) || value['colors'] === undefined) return false;
    return true;
}

export function PlayslipThemeUpdateRequestFromJSON(json: any): PlayslipThemeUpdateRequest {
    return PlayslipThemeUpdateRequestFromJSONTyped(json, false);
}

export function PlayslipThemeUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayslipThemeUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': json['messages'] == null ? undefined : json['messages'],
        'partnerLogoUrl': json['partnerLogoUrl'] == null ? undefined : json['partnerLogoUrl'],
        'colors': PlayslipThemeColorsFromJSON(json['colors']),
    };
}

export function PlayslipThemeUpdateRequestToJSON(value?: PlayslipThemeUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'messages': value['messages'],
        'partnerLogoUrl': value['partnerLogoUrl'],
        'colors': PlayslipThemeColorsToJSON(value['colors']),
    };
}

